import ShareChannelPicker from '../share-channel-picker';
export var shareChannelMap = ShareChannelPicker.Channel;
export var shareChannelList = ShareChannelPicker.channelList;
export var shareChannelCollection = ShareChannelPicker.channelCollection;
export var normalizeChannels = ShareChannelPicker.normalizeChannels;